<template>
  <div class="result">
    <van-dialog v-model="show" :show-confirm-button="false">
      <div v-if="result >= 0">
       <div class="base-css" style="padding-top: 12px">
         <van-image :src="imageView(player.avatar)" width="160px" height="240px" fit="contain"></van-image>
         <van-form>
           <van-field
             readonly
             clickable
             :value="player.trueName + ' ('+ player.teamName +')'"
             label="姓名"
             input-align="right"
           />
           <van-field
             readonly
             clickable
             :value="player.group"
             label="参赛组别"
             input-align="right"
           />
           <van-field
             readonly
             clickable
             name="picker"
             label="最近赛程"
             input-align="right"
           >
             <template #input>
               <div>
                 <div>{{ formatDate(game.date) }} </div>
                 <div>{{ game.homeTeamName }} <span v-if="game.homeTeamName && game.awayTeamName">vs</span> {{ game.awayTeamName }} <span v-if="game.location">(</span>{{ game.location }}<span v-if="game.location">)</span></div>
               </div>
             </template>
           </van-field>
         </van-form>
       </div>
       <div class="base-css" v-if="result > 0">
         <div class="status _1">检录通过</div>
         <div  class="description">参赛证信息符合检录规则，是否通过检录?</div>
         <div class="btns">
           <van-button class="btn" type="info" @click="confirmInspectionResult(1)">检录通过</van-button>
           <van-button class="btn" type="danger" plain @click="confirmInspectionResult(0)">检录失败</van-button>
         </div>
       </div>
       <div class="base-css" v-else>
         <div class="status _2">检录失败</div>
         <div  class="description">提醒：参赛证信息不符合检录规则；点击“继续扫码”将继续检录</div>
         <div class="btns">
           <van-button style="height: 38px; border-radius: 4px;" type="info" block @click="doRollCall">继续检录</van-button>
         </div>
       </div>
     </div>
      <div v-else class="base-css">
        <div style="padding: 190px 12px;">
          <div style="font-size: 30px; font-weight: 500">扫码错误</div>
          <div style="font-size: 12px; text-align: center">请扫描正确的二维码</div>
        </div>
        <div class="btns">
          <van-button style="height: 38px; border-radius: 4px;" type="info" block @click="doRollCall">继续检录</van-button>
        </div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import Vue from 'vue'
import { Dialog, Image as VanImage, Form, Field, Button, Toast } from "vant";
import { checkPlayerByScan, confirmInspectionResult } from '@/api/match'
import { DateUtil, QNImageUtil } from '@/utils'
Vue.use(Dialog).use(VanImage).use(Form).use(Field).use(Button).use(Toast)
export default {
  data() {
    return {
      matchId: '',
      playerId: '',
      show: true,
      player: {},
      game: {
        date: '',
        homeTeamName: '',
        awayTeamName: '',
        location: ''
      },
      result: ''
    }
  },
  mounted() {
    window.onPlayCardScanResult = result => {
      const { code } = result
      if (/[0-9]+[?]playerId=[0-9]+/.test(code)) {
        this.$router.push(`/match-manage/result/${code}`)
      } else {
        Toast('请扫码正确二维码')
      }
    }
    this.matchId = this.$route.params.matchId
    this.playerId = this.$route.query.playerId
    this.checkPlayerByScan()
  },
  methods: {
    checkPlayerByScan() {
      const params = {
        matchId: this.matchId,
        playerId: this.playerId
      }
      checkPlayerByScan(params).then(res => {
        const { data } = res
        this.result = data.result
        this.player = data.player
        this.game = data.game
      })
    },
    imageView(img) {
      if (!img) {
        return ''
      }
      return QNImageUtil.imageView(img)
    },
    formatDate(date) {
      if (!date) return ''
      return DateUtil.parseDateTime(date, '{y}-{m}-{d} {h}:{i}')
    },
    confirmInspectionResult(type) {
      let message = ''
      if (type === 1) {
        message = '是否确认要通过该选手'
      } else {
        message = '是否确认要拒绝该选手'
      }
      Dialog.confirm({
        title: '操作确认',
        message: message,
      }).then(() => {
        const params = {
          matchId: this.matchId,
          playerId: this.playerId,
          result: type
        }
        confirmInspectionResult(params).then(res => {
          if (res) {
            if (type === 1) {
              message = '通过成功，请继续检录'
            } else {
              message = '拒绝成功，请继续检录'
            }
            Dialog.alert({
              message: message,
            }).then(() => {
              this.doRollCall()
            })
          }
        })
      })
    },
    doRollCall() {
      window.location.href = 'banmabang://playercardscan2'
    }
  }
}
</script>

<style lang="scss">
.result {
  background-color: #000000;
  min-height: 100vh;
  .base-css {
    display: flex;
    flex-flow: column;
    align-items: center;
    padding: 0 12px;
    .status {
    }
    ._1 {
      color: #0ABB58;
    }
    ._2 {
      color: #F94242;
    }
    .description {
      font-size: 12px;
      color: #333333;
    }
    .btns {
      width: 270px;
      display: flex;
      justify-content: space-between;
      padding: 4px 12px 12px 12px;
      .btn {
        border-radius: 4px;
        width: 110px;
        height: 38px;
      }
    }
  }
}
</style>
